import { Field, Form, FormikContextType, FormikProvider } from "formik";
import { Checkbox, FormControlLabel, FormControlProps, FormGroup } from "@mui/material";

export type CheckBoxOption = {
    label: string;
    value: string;
};

export type CheckBoxesValues = Record<string, boolean>;

export interface CheckBoxesProps<V> {
    options: CheckBoxOption[];
    formik: FormikContextType<V>;
    formControlProps?: FormControlProps;
}

function CheckBoxes<V = CheckBoxesValues>(props: CheckBoxesProps<V>) {
    const { options, formik } = props;

    return (
        <FormikProvider value={formik}>
            <Form>
                <FormGroup>
                    {options.map(option => (
                        <Field
                            type="checkbox"
                            key={option.value}
                            name={option.value}
                            label={option.label}
                            as={FormControlLabel}
                            control={<Checkbox />}
                            {...props.formControlProps}
                        />
                    ))}
                </FormGroup>
            </Form>
        </FormikProvider>
    );
}

export default CheckBoxes;
